<comp-product-header
  [details]="details()"
  [isEditing]="isEditing()"
  [isSubmitting]="submitting()"
  [model]="editModel()"
  (editRequested)="onEdit()"
  (cancelRequested)="onCancel()"
  (modelChanged)="onEditModelChanged($event)"
  (saveRequested)="onSave()"
></comp-product-header>

<article class="ul-card">
  <comp-card-header>
    <span headline>{{ 'model.product.references.revisions' | translate }}</span>
    <div action-items class="prime-action-bar">
      <button type="button" comp-button (click)="addRevision()">
        <i comp-icon>add</i>
        <span>{{ 'revisions.add' | translate }}</span>
      </button>
    </div>
  </comp-card-header>
  <comp-revisions-table
    [dataSource]="dataSource"
    [editingSupport]="editingSupport()"
    (evidenceOpened)="openEvidences($event)"
  ></comp-revisions-table>
</article>
